export const MAX_ALLOWED_MAIN_COMPETITORS = 4;

export const LOADER_HEIGHT = 40;
export const LOADER_WIDTH = 500;

export const SIMILAR_ITEM_TYPE = "similar";

export const MIN_COMPETITORS_LENGTH = 3;
export const FULL_AUTOCOMPLETE_HEIGHT = "100%";
export const MIN_AUTOCOMPLETE_HEIGHT = "120px";
